import {debounce, DebounceSettings} from 'lodash';
import {useCallback, useRef} from 'react';

export function useDebouncedCallback<T extends (...args: any) => any>(
   cb: T,
   timeout = 0
   // settings?: DebounceSettings
) {
   const ref = useRef<T>(cb);
   ref.current = cb;

   const fn = useCallback(debounce(ref.current, timeout, {leading: true}), [ref, timeout]);
   return fn;
}
